export default (type, attributes) => ({
  data: {
    type,
    attributes,
  },
});



// WEBPACK FOOTER //
// ./src/utils/apiSchemaGenerator.js